// extracted by mini-css-extract-plugin
export default {"r_l":"_3b09fbc148 _1f0505a1ff","t":"_7dadfb7d7b"};